// extracted by mini-css-extract-plugin
module.exports = {"container":"rule_container__2I7aj","content":"rule_content__2r5uP","text_mark":"rule_text_mark__8ANSh","text":"rule_text__5zyUC","text_gap":"rule_text_gap__93ka-"};